module.exports = __webpack_public_path__ + "img/STERiGLIDE_00_01.3860eee8.png";